import { render } from "./SpecifiedCommercial.vue?vue&type=template&id=2127d970&scoped=true"
import script from "./SpecifiedCommercial.vue?vue&type=script&lang=js"
export * from "./SpecifiedCommercial.vue?vue&type=script&lang=js"

import "./SpecifiedCommercial.vue?vue&type=style&index=0&id=2127d970&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2127d970"]])

export default __exports__